/**
 * Chỉ những icon web thực sự dùng. Import từng component (named export) thay vì
 * cả map IconComponents của generated-icons.tsx (149 SVG inline, ~760KB nguồn) —
 * nhờ vậy webpack tree-shake phần còn lại, chunk dùng chung trang chủ nhẹ hẳn.
 * Dùng icon mới? Thêm 1 dòng vào đây (nếu thiếu, Icons() trả null + console.warn).
 */
import type React from "react";
import type { IconName, IconComponentProps } from "./generated-icons";
import {
  IconAppstore,
  IconArrowRight,
  IconCalendar,
  IconCategoryGym,
  IconCategoryLifeCoach,
  IconCategoryMassage,
  IconCategorySalon,
  IconCategorySpa,
  IconCategoryThamMy,
  IconCategoryToc,
  IconCategoryWorkshop,
  IconCrown,
  IconExplore,
  IconGoogleplay,
  IconHome,
  IconLocation,
  IconLogoBlack,
  IconLogoColor,
  IconLogoCommingSoon,
  IconLogo,
  IconSale,
  IconSunFog,
  IconTime,
} from "./generated-icons";

export const IconComponents: Partial<Record<IconName, (p: IconComponentProps) => React.JSX.Element>> = {
  'appstore': IconAppstore,
  'arrow-right': IconArrowRight,
  'calendar': IconCalendar,
  'category-gym': IconCategoryGym,
  'category-life-coach': IconCategoryLifeCoach,
  'category-massage': IconCategoryMassage,
  'category-salon': IconCategorySalon,
  'category-spa': IconCategorySpa,
  'category-tham-my': IconCategoryThamMy,
  'category-toc': IconCategoryToc,
  'category-workshop': IconCategoryWorkshop,
  'crown': IconCrown,
  'explore': IconExplore,
  'googleplay': IconGoogleplay,
  'home': IconHome,
  'location': IconLocation,
  'logo-black': IconLogoBlack,
  'logo-color': IconLogoColor,
  'logo-comming-soon': IconLogoCommingSoon,
  'logo': IconLogo,
  'sale': IconSale,
  'sun-fog': IconSunFog,
  'time': IconTime,
};
